(function () {

// Guard so the IIFE body only runs once even if the file is loaded multiple times
if (window._bentBoxInitialized) return;
window._bentBoxInitialized = true;

// Global flag to prevent multiple accordion initializations
window.accordionsInitialized = false;

document.addEventListener('DOMContentLoaded', function () {
// Reset flag when page is loaded
window.accordionsInitialized = false;

initBentoBox();
initBentoBoxVideos();

// Initialize accordions once with delay
setTimeout(function () {
initBentoBoxAccordions();
    }, 500);

// Custom event to reinitialize accordions if needed
document.addEventListener('reinit-bento-accordions', function () {
window.accordionsInitialized = false;
initBentoBoxAccordions();
    });
  });

// Only define the class if it doesn't already exist
if (typeof window.BentoBoxSwiper === 'undefined') {
window.BentoBoxSwiper = class BentoBoxSwiper {
constructor() {
this.sections = document.querySelectorAll('.bento-box');
this.retryCount = 0;
this.maxRetries = 10; // 10 × 500ms = 5 seconds max wait
this.init();
      }

init() {
this.sections.forEach(section => {
const swiperContainer = section.querySelector('.bento-box-swiper');
const gridContainer = section.querySelector('.bento-box__grid');
const sliderContainer = section.querySelector('.bento-box__slider');

if (!swiperContainer || !gridContainer || !sliderContainer) return;

if (
typeof customElements === 'undefined' ||
!customElements.get('swiper-container') ||
typeof swiperContainer.initialize === 'undefined'
          ) {
if (this.retryCount >= this.maxRetries) {
console.warn('Swiper Element failed to load after ' + this.maxRetries + ' retries. Keeping grid layout.');
return;
            }
this.retryCount++;
console.log('Swiper Element not available yet, will retry (' + this.retryCount + '/' + this.maxRetries + ')');
setTimeout(() => this.init(), 500);
return;
          }

const params = {
injectStyles: [
`:host {
                display: block;
                width: 100%;
              }
              .swiper {
                width: 100%;
                overflow: visible;
              }
              .swiper-slide {
                position: relative;
              }
              ::slotted(swiper-slide) {
                height: auto;
              }`
            ],
init: true,
slidesPerView: 1.1,
spaceBetween: 20,
watchOverflow: true,
observer: true,
observeParents: true,
resizeObserver: true,
speed: 300,
autoHeight: false,
effect: 'slide',
on: {
beforeInit() {
if (this.el) {
this.el.style.display = 'block';
this.el.style.width = '100%';
                }
              },
init(swiper) {
this.slideTo(0);
setTimeout(() => { swiper.update(); }, 50);
              }
            }
          };

Object.assign(swiperContainer, params);

const showMobileSlider = sliderContainer.getAttribute('data-show-mobile-slider') === 'true';

if (showMobileSlider && window.innerWidth <= 749) {
sliderContainer.style.display = 'block';
gridContainer.style.display = 'none';
          }

swiperContainer.initialize();

const handleResize = () => {
const showMobileSlider = sliderContainer.getAttribute('data-show-mobile-slider') === 'true';

if (window.innerWidth <= 749) {
if (showMobileSlider) {
gridContainer.style.display = 'none';
sliderContainer.style.display = 'block';
if (swiperContainer.swiper) {
setTimeout(() => { swiperContainer.swiper.update(); }, 100);
                }
              } else {
gridContainer.style.display = 'grid';
sliderContainer.style.display = 'none';
              }
            } else {
gridContainer.style.display = 'grid';
sliderContainer.style.display = 'none';
            }
          };

handleResize();
window.addEventListener('resize', handleResize);
        });
      }

destroy() {
this.sections.forEach(section => {
const swiperContainer = section.querySelector('.bento-box-swiper');
if (swiperContainer && swiperContainer.swiper) {
swiperContainer.swiper.destroy();
          }
        });
      }
    };
  }

function initBentoBoxVideos() {
const videoPlaceholders = document.querySelectorAll('.bento-box__video-placeholder');

videoPlaceholders.forEach(placeholder => {
placeholder.addEventListener('click', function () {
const videoContainer = this.closest('.bento-box__video-container');
const videoEmbed = videoContainer.querySelector('.bento-box__video-embed');
const videoType = videoEmbed.dataset.videoType;
const videoId = videoEmbed.dataset.videoId;

if (!videoType || !videoId) return;

this.style.display = 'none';
videoEmbed.style.display = 'block';
videoEmbed.innerHTML = '';

if (videoType === 'vimeo') {
const iframe = document.createElement('iframe');
iframe.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0`;
iframe.width = '100%';
iframe.height = '100%';
iframe.allow = 'autoplay; fullscreen; picture-in-picture';
iframe.frameBorder = '0';
iframe.style.aspectRatio = '16/9';
videoEmbed.appendChild(iframe);
        } else if (videoType === 'youtube') {
const iframe = document.createElement('iframe');
iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`;
iframe.width = '100%';
iframe.height = '100%';
iframe.allow = 'autoplay; fullscreen; picture-in-picture';
iframe.frameBorder = '0';
iframe.style.aspectRatio = '16/9';
videoEmbed.appendChild(iframe);
        } else if (videoType === 'shopify') {
const videoElement = document.createElement('video');
try {
const videoData = JSON.parse(videoId);
if (videoData && videoData.sources && videoData.sources.length) {
videoElement.src = videoData.sources[0].url;
            } else {
console.error('Invalid Shopify video data structure', videoData);
return;
            }
          } catch (e) {
console.error('Error parsing video data:', e);
return;
          }
videoElement.controls = true;
videoElement.autoplay = true;
videoElement.width = '100%';
videoElement.height = '100%';
videoElement.style.aspectRatio = '16/9';
videoEmbed.appendChild(videoElement);
        }
      });
    });
  }

if (typeof window.bentoSwiper === 'undefined') {
window.bentoSwiper = null;
  }

function initBentoBox() {
if (window.bentoSwiper) {
window.bentoSwiper.destroy();
    }
window.bentoSwiper = new window.BentoBoxSwiper();
  }

function initBentoBoxAccordions() {
if (window.accordionsInitialized) return;

const toggleButtons = document.querySelectorAll('.bento-box__accordion-toggle');

if (toggleButtons.length === 0) {
setTimeout(initBentoBoxAccordions, 500);
return;
    }

window.accordionsInitialized = true;

document.querySelectorAll('.bento-box__items-tested-content, .bento-box__faq-content').forEach(content => {
content.style.maxHeight = '0px';
content.style.overflow = 'hidden';
    });

toggleButtons.forEach(toggle => {
const newToggle = toggle.cloneNode(true);
toggle.parentNode.replaceChild(newToggle, toggle);
    });

document.querySelectorAll('.bento-box__accordion-toggle').forEach(toggle => {
toggle.addEventListener('click', function (e) {
e.preventDefault();

const content = this.nextElementSibling;
if (!content) return;

const parentAccordion = this.closest('.bento-box__faq-accordion, .bento-box__items-tested-accordion');
const isCurrentlyActive = content.classList.contains('active');

if (parentAccordion) {
parentAccordion.querySelectorAll('.bento-box__accordion-toggle').forEach(otherToggle => {
otherToggle.classList.remove('active');
const otherContent = otherToggle.nextElementSibling;
if (otherContent) {
otherContent.classList.remove('active');
otherContent.style.maxHeight = '0px';
otherContent.style.paddingBottom = '0px';
            }
          });
        }

if (!isCurrentlyActive) {
this.classList.add('active');
content.classList.add('active');
content.style.maxHeight = content.scrollHeight + 'px';
content.style.paddingBottom = '15px';
        }
      });
    });
  }

// Make initBentoBoxAccordions available globally for the inline script in the Liquid template
window.initBentoBoxAccordions = initBentoBoxAccordions;
window.initBentoBox = initBentoBox;
window.initBentoBoxVideos = initBentoBoxVideos;

document.addEventListener('shopify:section:load', function (event) {
if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
window.accordionsInitialized = false;
setTimeout(function () {
initBentoBox();
initBentoBoxVideos();
initBentoBoxAccordions();
      }, 300);
    }
  });

document.addEventListener('shopify:section:select', function (event) {
if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
initBentoBox();
    }
  });

document.addEventListener('shopify:section:deselect', function (event) {
if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
initBentoBox();
    }
  });

document.addEventListener('shopify:block:select', function (event) {
if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
initBentoBox();
    }
  });

document.addEventListener('shopify:block:deselect', function (event) {
if (event.detail.sectionId && event.detail.sectionId.includes('bento-box')) {
initBentoBox();
    }
  });

})();